import React from 'react';
import { FormattedMessage } from 'react-intl';

import LinkButton from 'box-ui-elements/es/components/link/LinkButton';
import { Text } from '@box/blueprint-web';
import css from './spoofed-url-redirect-page.module.scss';
import messages from './messages';

interface Props {
  verifiedUrl: string;
}

export const SpoofedUrlRedirectPage = ({ verifiedUrl }: Props) => {
  const currentURL = window.location.href;

  return (
    <div className={css.container} data-testid="spoofed-url-redirect-page">
      <div className={css.spoofedUrlBlock}>
        {/*
         // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2820 */}
        <Text as="h1" variant="title-xlarge" color="text-on-dark-default">
          <FormattedMessage {...messages.pageTitle} />
        </Text>

        {/*
         // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2820 */}
        <Text as="p" color="text-on-dark-default">
          <FormattedMessage
            values={{ currentURL }}
            {...messages.currentURLText}
          />
        </Text>
        {/*
         // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2820 */}
        <Text as="p" color="text-on-dark-default">
          <FormattedMessage
            values={{ verifiedUrl }}
            {...messages.verifiedURLText}
          />
        </Text>
        {/*
         // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2820 */}
        <Text as="p" color="text-on-dark-default">
          <FormattedMessage {...messages.infoText} />
        </Text>
        <div className={css.spoofedUrlButtons}>
          <LinkButton
            to="/"
            href="/"
            data-testid="spoofed-url-redirect-cancel-button"
          >
            <FormattedMessage {...messages.cancelButtonText} />
          </LinkButton>
          <LinkButton
            data-testid="spoofed-url-redirect-continue-button"
            to={verifiedUrl}
            href={verifiedUrl}
            className="btn-primary"
          >
            <FormattedMessage {...messages.continueButtonText} />
          </LinkButton>
        </div>
      </div>
    </div>
  );
};
